$(document).ready(function () {
    // Function to retrieve pet data from local storage
    function getPetData() {
        var storedData = window.localStorage.getItem('quiz-data');
        if (storedData) {
            return JSON.parse(storedData);
        }
        return [];
    }

    // Function to generate the menu
    function generateMenu(petData) {
        var menu = $('<ul class="pet-menu"></ul>');
        petData.forEach(function (pet, index) {
            var menuItem = $('<li class="pet-menu-item" ></li>').html('<a class="results-link" href="/pages/quiz-results?Name=' + pet.Name + '">' + pet.Name + '&apos;s recommendation </a><span class="remove">X</span>');
            menuItem.attr('data-index', index);
            menu.append(menuItem);
        });
        return menu;
    }

    // Function to display the menu
    function displayMenu() {
        var petData = getPetData();
        if (petData.length > 0) {
            var menu = generateMenu(petData);
            $('.menu-container').html(menu);
            $('.quiz-button')[0].innerText = 'Take a new quiz';
        } else {
            // $('.menu-container').html('<p style="margin:auto;width:fit-content">No test completed.</p>');
            // $('.additional-pet-text')[0].innerText = 'Answer a few quick questions, and we\'ll recommend the ideal formula for your pet.';
            $('.additional-pet-text')[0].innerText = '';
        }
    }

    // Call displayMenu on page load
    displayMenu();


    // Event listener for remove button click
    $(document).on('click', '.remove', function () {
        var index = $(this).parent().attr('data-index');
        var petData = getPetData();
        petData.splice(index, 1);
        window.localStorage.setItem('quiz-data', JSON.stringify(petData));
        displayMenu();
    });
});